"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsDownloadFromExternalUrlPending = exports.getRecentlyUploadedFiles = exports.getUploadRequestsById = exports.getSingleFileDetails = void 0;

var _reselect = require("reselect");

var _Files = require("./Files");

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var _Constants = require("../Constants");

var getSingleFileDetails = function getSingleFileDetails(state) {
  return state.fileDetails.get('fileDetails');
};

exports.getSingleFileDetails = getSingleFileDetails;

var getUploadRequestsById = function getUploadRequestsById(state) {
  return state.fileDetails.get('uploadRequestsById');
};

exports.getUploadRequestsById = getUploadRequestsById;

var getCurrentFolderId = function getCurrentFolderId(state, _ref) {
  var folderId = _ref.folderId;
  return folderId;
};

var getRecentlyUploadedFiles = (0, _reselect.createSelector)([getCurrentFolderId, _Files.getFetchFilesTimestamp, getSingleFileDetails, getUploadRequestsById], function (currentFolderId, timestamp, singleFileDetails, uploadRequests) {
  return (0, _FoldersAndFiles.filterRecentlyUploadedFiles)(singleFileDetails, uploadRequests, currentFolderId);
});
exports.getRecentlyUploadedFiles = getRecentlyUploadedFiles;

var getIsDownloadFromExternalUrlPending = function getIsDownloadFromExternalUrlPending(state) {
  return state.fileDetails.get('downloadFromExternalUrlStatus') === _Constants.RequestStatus.PENDING;
};

exports.getIsDownloadFromExternalUrlPending = getIsDownloadFromExternalUrlPending;